var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    stroke: "#E1E3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 14.3331V18.4998H14.8183M14.8183 18.4998C15.3715 17.1316 16.363 15.9855 17.6374 15.2413C18.9119 14.4971 20.3973 14.1968 21.8607 14.3874C23.3242 14.578 24.6831 15.2488 25.7244 16.2946C26.7657 17.3404 27.4306 18.7022 27.6149 20.1664M14.8183 18.4998H18.4999M27.6666 27.6664V23.4998H27.1824M27.1824 23.4998C26.6284 24.8672 25.6366 26.0123 24.3623 26.7559C23.0879 27.4994 21.603 27.7994 20.14 27.6088C18.677 27.4183 17.3184 26.748 16.277 25.7029C15.2356 24.6578 14.5702 23.2968 14.3849 21.8331M27.1824 23.4998H23.4999",
    stroke: "#003056",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadBlue);
export default __webpack_public_path__ + "static/media/Reload-blue.12b249bb6b4dc5f0d8f133d733abaf04.svg";
export { ForwardRef as ReactComponent };